var _circle, _path, _path2, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessNocomplete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 37,
    cy: 37,
    r: 36.5,
    fill: "#F2F2F2",
    stroke: "#AFAFAF",
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3372 32.9538L41.6798 42.9005L40.0225 32.9538C39.9827 32.7133 39.9958 32.467 40.0608 32.232C40.1258 31.9971 40.2411 31.7791 40.3988 31.5932C40.5565 31.4073 40.7528 31.2579 40.974 31.1555C41.1952 31.0531 41.4361 31 41.6798 31C41.9236 31 42.1645 31.0531 42.3857 31.1555C42.6069 31.2579 42.8032 31.4073 42.9608 31.5932C43.1185 31.7791 43.2339 31.9971 43.2989 32.232C43.3639 32.467 43.3769 32.7133 43.3372 32.9538Z",
    stroke: "#AFAFAF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6799 51.4989C42.4104 51.4989 43.0026 50.9067 43.0026 50.1762C43.0026 49.4457 42.4104 48.8535 41.6799 48.8535C40.9494 48.8535 40.3572 49.4457 40.3572 50.1762C40.3572 50.9067 40.9494 51.4989 41.6799 51.4989Z",
    stroke: "#AFAFAF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 41,
    r: 36.5,
    stroke: "#AFAFAF",
    strokeDasharray: "5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessNocomplete);
export default __webpack_public_path__ + "static/media/process_nocomplete.928dadcd92a640aeeb35287f0e1c00cc.svg";
export { ForwardRef as ReactComponent };